import React from "react";

const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Team</h2>
        </div>
        <div id="row">
          <div className="thumbnails">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                  <div className="thumbnail">
                  <a id="manager" href="https://www.linkedin.com/in/merrais/" label="merrais" target="_blank" rel="noopener noreferrer">
                    <img src={d.img} alt="..." className="team-img" />
                  </a>
                    <div className="caption">
                      <p style={{fontSize:'1.5rem'}}>{d.name}</p>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
            </div>
        </div>
      </div>
    </div>
  );
};

export {Team}